var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 170.67
  })), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFEBFF"
    },
    points: "256,206.664 214.9,267.105 297.1,267.105 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#557DE6"
    },
    points: "214.9,267.105 188.306,305.788 323.694,305.788 297.1,267.105 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M266.518,263.727c0.164-0.338,0.336-0.669,0.484-1.014   C266.854,263.057,266.682,263.39,266.518,263.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M267.649,260.941c0.1-0.303,0.223-0.599,0.309-0.907   C267.872,260.342,267.749,260.637,267.649,260.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M265.119,266.264c0.207-0.331,0.413-0.66,0.607-1C265.533,265.604,265.326,265.934,265.119,266.264z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M271.402,255.004c-0.367,0-0.72,0.06-1.045,0.17C270.682,255.064,271.035,255.004,271.402,255.004   L271.402,255.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M269.478,255.642c-0.513,0.399-0.862,0.956-0.941,1.592l-0.001,0.004l0.001-0.004   C268.616,256.598,268.965,256.04,269.478,255.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M268.231,273.681c0.577,0.546,1.147,1.067,1.72,1.562c3.068-2.656,6.27-6.031,8.517-9.979   c-0.161,0.283-0.336,0.557-0.506,0.835c-2.098-3.859-3.206-7.197-3.743-9.176c-0.307-1.131-1.476-1.917-2.811-1.919   C271.92,259.514,273.024,267.799,268.231,273.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M280.391,260.941c0.1-0.303,0.223-0.599,0.309-0.907   C280.613,260.342,280.491,260.637,280.391,260.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M282.219,255.642c-0.513,0.399-0.862,0.956-0.941,1.592l-0.001,0.004l0.001-0.004   C281.358,256.598,281.707,256.04,282.219,255.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M279.26,263.727c0.164-0.338,0.336-0.669,0.484-1.014   C279.596,263.057,279.423,263.39,279.26,263.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M305.36,276.776c-4.66,0-9.07-2.236-11.762-6.04c-4.055-5.73-5.894-11.072-6.638-13.813   c-0.307-1.132-1.479-1.919-2.816-1.919l0.005,0.001c0.612,5.381,2.073,16.142-6.671,21.772h-5.693   c-0.234-0.186-0.462-0.362-0.7-0.558c0.005,0.004,0.01,0.009,0.016,0.014c-1.593,2.08-4.78,2.663-7.252,1.39   c-10.347-5.331-8.739-16.956-8.095-22.617c-1.335,0.002-2.504,0.788-2.811,1.919c-0.537,1.979-1.645,5.317-3.743,9.176   c-0.171-0.277-0.345-0.552-0.506-0.835c2.528,4.442,6.278,8.19,9.666,10.967c-1.593,2.08-4.78,2.663-7.252,1.39   c-10.347-5.331-8.739-16.956-8.095-22.617c-1.335,0.002-2.504,0.788-2.811,1.919c-0.537,1.979-1.645,5.317-3.743,9.176   c-0.171-0.277-0.345-0.552-0.506-0.835c2.528,4.442,6.278,8.19,9.666,10.967c-1.593,2.08-4.78,2.663-7.252,1.39   c-10.347-5.331-8.739-16.956-8.095-22.617l0.005-0.001c-1.337,0-2.509,0.787-2.816,1.919c-0.744,2.741-2.583,8.082-6.638,13.813   c-2.692,3.804-7.101,6.04-11.762,6.04h-3.829v4.835h99.124h2.418v-4.835h-1.414L305.36,276.776L305.36,276.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M260.158,262.713c0.148,0.345,0.32,0.676,0.484,1.014   C260.478,263.39,260.305,263.057,260.158,262.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M259.201,260.034c0.086,0.308,0.209,0.604,0.309,0.907   C259.41,260.637,259.288,260.342,259.201,260.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M258.623,257.237l-0.001-0.004c-0.079-0.635-0.428-1.193-0.941-1.592   c0.513,0.399,0.862,0.956,0.941,1.592L258.623,257.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M261.433,265.264c0.193,0.34,0.399,0.669,0.606,1C261.833,265.934,261.626,265.604,261.433,265.264z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M263.655,268.616c-0.025-0.032-0.048-0.066-0.072-0.099c0.207-0.276,0.407-0.555,0.606-0.838   c-0.198,0.282-0.402,0.558-0.609,0.833c-0.206-0.275-0.411-0.552-0.609-0.833C263.194,267.997,263.421,268.307,263.655,268.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M264.717,269.954c0.236,0.283,0.469,0.563,0.711,0.838   C265.187,270.518,264.952,270.236,264.717,269.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M267.299,272.79c-0.225-0.225-0.446-0.462-0.669-0.695   C266.854,272.328,267.073,272.564,267.299,272.79z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M284.149,255.004l-0.005-0.001c-0.735,0-1.411,0.24-1.924,0.638  c-0.513,0.399-0.862,0.956-0.941,1.592l-0.001,0.004c-0.119,0.953-0.322,1.884-0.578,2.797c-0.086,0.308-0.209,0.604-0.309,0.907  c-0.198,0.598-0.4,1.194-0.647,1.773c-0.148,0.345-0.32,0.676-0.484,1.014c-0.251,0.519-0.507,1.036-0.792,1.537  c-2.247,3.947-5.449,7.323-8.517,9.979c-0.573-0.496-1.143-1.016-1.72-1.562c4.793-5.882,3.689-14.167,3.176-18.676l-0.005-0.001  c-0.367,0-0.72,0.06-1.045,0.17s-0.623,0.269-0.879,0.468c-0.513,0.399-0.862,0.956-0.941,1.592l-0.001,0.004  c-0.119,0.953-0.322,1.884-0.578,2.797c-0.086,0.308-0.209,0.604-0.309,0.907c-0.198,0.598-0.4,1.194-0.647,1.773  c-0.148,0.345-0.32,0.676-0.484,1.014c-0.251,0.519-0.507,1.036-0.792,1.537c-0.193,0.34-0.399,0.669-0.607,1  c-0.3,0.479-0.606,0.954-0.931,1.415c-0.199,0.283-0.399,0.562-0.606,0.838c-0.208-0.276-0.412-0.554-0.612-0.838  c-0.325-0.461-0.631-0.936-0.931-1.415c-0.207-0.331-0.413-0.66-0.606-1c-0.286-0.501-0.541-1.018-0.792-1.537  c-0.164-0.338-0.336-0.669-0.484-1.014c-0.248-0.578-0.449-1.175-0.647-1.773c-0.1-0.303-0.223-0.599-0.309-0.907  c-0.256-0.913-0.458-1.844-0.578-2.797l-0.001-0.004c-0.079-0.636-0.428-1.193-0.941-1.592c-0.513-0.398-1.189-0.638-1.924-0.638  l-0.005,0.001c-0.644,5.661-2.251,17.286,8.095,22.617c1.745,0.899,3.838,0.865,5.48,0.037c1.049-0.529,2.174-0.882,3.348-0.882  h4.801C286.222,271.146,284.761,260.386,284.149,255.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M246.459,260.034c0.086,0.308,0.209,0.604,0.309,0.907   C246.668,260.637,246.546,260.342,246.459,260.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M245.882,257.237l-0.001-0.004c-0.079-0.635-0.428-1.193-0.941-1.592   c0.513,0.399,0.862,0.956,0.941,1.592L245.882,257.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M247.416,262.713c0.148,0.345,0.32,0.676,0.484,1.014   C247.736,263.39,247.563,263.057,247.416,262.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M243.016,255.004L243.016,255.004c0.367,0,0.72,0.06,1.045,0.17   C243.736,255.064,243.383,255.004,243.016,255.004z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M251.106,277.621c2.472,1.273,5.659,0.69,7.252-1.39c-3.388-2.777-7.138-6.525-9.666-10.967  c-0.286-0.501-0.541-1.018-0.792-1.537c-0.164-0.338-0.336-0.669-0.484-1.014c-0.248-0.578-0.449-1.175-0.647-1.773  c-0.1-0.303-0.223-0.599-0.309-0.907c-0.256-0.913-0.458-1.844-0.578-2.797l-0.001-0.004c-0.079-0.636-0.428-1.193-0.941-1.592  c-0.256-0.199-0.554-0.359-0.879-0.468c-0.325-0.109-0.678-0.17-1.045-0.17l0,0l-0.005,0.001l0,0  C242.367,260.665,240.759,272.29,251.106,277.621z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M233.718,260.034c0.086,0.308,0.209,0.604,0.309,0.907   C233.927,260.637,233.804,260.342,233.718,260.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M234.674,262.713c0.148,0.345,0.32,0.676,0.484,1.014   C234.994,263.39,234.822,263.057,234.674,262.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M233.14,257.237l-0.001-0.004c-0.079-0.635-0.428-1.193-0.941-1.592   c0.513,0.399,0.862,0.956,0.941,1.592L233.14,257.237z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M238.364,277.621c2.472,1.273,5.659,0.69,7.252-1.39c-3.388-2.777-7.138-6.525-9.666-10.967  c-0.286-0.501-0.541-1.018-0.792-1.537c-0.164-0.338-0.336-0.669-0.484-1.014c-0.248-0.578-0.449-1.175-0.647-1.773  c-0.1-0.303-0.223-0.599-0.309-0.907c-0.256-0.913-0.458-1.844-0.578-2.797l-0.001-0.004c-0.079-0.636-0.428-1.193-0.941-1.592  c-0.513-0.398-1.189-0.638-1.924-0.638l-0.005,0.001C229.625,260.665,228.017,272.29,238.364,277.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M235.631,235.78c-0.201,0.771-0.402,1.542-0.603,2.314c6.6-1.979,13.882-3.168,21.787-3.168  c7.903,0.004,15.187,1.185,21.787,3.168c-0.201-0.772-0.402-1.543-0.603-2.314c-6.565-1.694-13.631-2.668-21.184-2.665  C249.263,233.113,242.197,234.085,235.631,235.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AA0E6"
    },
    d: "M235.893,234.774c-0.201,0.771-0.402,1.542-0.603,2.314c6.527-1.984,13.721-3.174,21.525-3.178  c7.804,0.003,14.999,1.193,21.525,3.178c-0.201-0.772-0.402-1.543-0.603-2.314c-6.492-1.706-13.467-2.672-20.922-2.675  C249.359,232.101,242.385,233.071,235.893,234.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC800"
    },
    d: "M236.136,233.844c-0.201,0.771-0.402,1.542-0.603,2.313c6.463-1.991,13.572-3.19,21.282-3.187  c7.712,0,14.821,1.196,21.282,3.187c-0.201-0.771-0.402-1.542-0.603-2.313c-6.421-1.705-13.313-2.684-20.679-2.684  C249.45,231.158,242.56,232.139,236.136,233.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE14E"
    },
    d: "M236.413,232.781c-0.201,0.772-0.402,1.543-0.603,2.314c6.386-1.997,13.401-3.198,21.005-3.198  c7.605,0.003,14.619,1.2,21.005,3.198c-0.201-0.771-0.402-1.542-0.603-2.314c-6.346-1.713-13.139-2.693-20.402-2.695  C249.553,230.088,242.758,231.068,236.413,232.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB14E"
    },
    d: "M236.685,231.738c-0.201,0.771-0.402,1.542-0.603,2.313c6.313-2.003,13.23-3.207,20.733-3.208  c7.502,0.005,14.421,1.202,20.733,3.208c-0.201-0.771-0.402-1.542-0.603-2.313c-6.268-1.716-12.968-2.704-20.13-2.706  C249.656,229.035,242.954,230.018,236.685,231.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M236.801,231.293c-0.141,0.54-0.281,1.08-0.422,1.62c6.23-2.005,13.049-3.221,20.437-3.22  c7.389-0.003,14.206,1.211,20.436,3.22c-0.141-0.54-0.281-1.08-0.422-1.62c-6.234-1.72-12.897-2.708-20.014-2.71  C249.698,228.578,243.036,229.57,236.801,231.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M323.695,308.135h-135.39c-0.892,0-1.712-0.491-2.132-1.275c-0.42-0.789-0.373-1.742,0.12-2.484  l67.695-101.542c0.897-1.341,3.126-1.341,4.023,0l67.695,101.542c0.493,0.741,0.541,1.695,0.12,2.484  C325.406,307.644,324.587,308.135,323.695,308.135z M192.822,303.3h126.356L256,208.534L192.822,303.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M260.624,245.213c0-2.126-2.156-5.361-5.606-5.361c-2.017,0-3.652,1.232-3.652,2.753  c0,0.759,0.408,1.446,1.066,1.943c-0.003,0.028-0.005,0.057-0.008,0.084c-0.824,0.505-1.361,1.265-1.361,2.128  c0,1.451,1.494,2.626,3.382,2.732l1.554,3.108l1.403-2.805C259.245,249.323,260.624,247.455,260.624,245.213z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNi);
export default __webpack_public_path__ + "static/media/NI.c6c62ef04167a6ef6d76ae4b051813f7.svg";
export { ForwardRef as ReactComponent };